import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { applicants } from "@/data/application-data";
import { AUTOSCORE, COLUMNS } from "@/constants/applications";
import Form from "react-bootstrap/Form";

const TableSearchInput = () => {
  return (
    <div className="me-3">
      <input
        className="form-control form-control-sm"
        type="text"
        placeholder="Search..."
        aria-label=".form-control-sm example"
      />
    </div>
  );
};

const CommunityFilter = () => {
  return (
    <div className="me-3">
      <Form.Select className="sm" aria-label="Default select example">
        <option>Filter by Community</option>
        <option value="1">ApproveShield Estates</option>
        <option value="2">Alista</option>
        <option value="3">Frankford Estates</option>
        <option value="4">AMLI Fountain Place</option>
      </Form.Select>
    </div>
  );
};

const ApplicationsTable = () => {
  const navigate = useNavigate();

  const goToAppHandler = useCallback(
    (data) => () => {
      if (!data || !data.id) return;
      navigate(`/screenings/${data?.id}`);
    },
    [navigate]
  );

  return (
    <div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card custom-card">
            <div className="card-header">
              {/* <div className="col">
                <div class="card-title mb-sm-0 mb-2">Screenings</div>
              </div> */}
              <div className="col">
                <TableSearchInput />
              </div>
              <div className="col col-3">
                <CommunityFilter />
              </div>
            </div>

            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table text-nowrap table-hover ">
                  <thead>
                    <tr>
                      {COLUMNS.map((col, x) => (
                        <th scope="col" key={x}>
                          {col.label}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {applicants?.map((data, x) => (
                      <TableRow
                        item={data}
                        key={x}
                        onClick={goToAppHandler(data)}
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card-footer">
              <div className="d-flex align-items-center">
                <div>
                  Showing 6 Entries
                  <i className="bi bi-arrow-right ms-2 fw-semibold"></i>
                </div>
                <div className="ms-auto">
                  <nav
                    aria-label="Page navigation"
                    className="pagination-style-4"
                  >
                    <ul className="pagination mb-0">
                      <li className="page-item disabled">
                        <a className="page-link">Prev</a>
                      </li>
                      <li className="page-item active">
                        <a className="page-link">1</a>
                      </li>
                      <li className="page-item">
                        <a className="page-link">2</a>
                      </li>
                      <li className="page-item">
                        <a className="page-link text-primary">next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const TableRow = ({ item, onClick }) => {
  return (
    <tr className="c-pointer" onClick={onClick}>
      <td className="py-3">
        <div className="d-flex align-items-center fw-semibold">
          {item?.name}
        </div>
        <div className="d-flex align-items-center fw-normal text-muted">
          {item?.email}
        </div>
      </td>
      <td>{item?.community?.name}</td>
      <td>{item?.screening_type}</td>

      <td>
        <span className="badge fs-12 bg-success-transparent">
          {item?.status}
        </span>
      </td>
      <td>
        <div className="d-inline-flex align-items-center">
          <span
            className={`badge fs-12 bg-${
              AUTOSCORE[item?.autoscore]?.variant
            }-transparent text-uppercase ms-1`}
          >
            {" "}
            {AUTOSCORE[item?.autoscore]?.label}
          </span>
        </div>
      </td>
      <td>{item?.created}</td>
    </tr>
  );
};

ApplicationsTable.propTypes = {};

export default ApplicationsTable;
